var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-popup",
    {
      staticStyle: { "z-index": "99990" },
      attrs: {
        "button-close-hidden": "",
        title: "Log # " + _vm.reference,
        active: _vm.$store.state.log_visibility
      },
      on: {
        "update:active": function($event) {
          return _vm.$set(_vm.$store.state, "log_visibility", $event)
        }
      }
    },
    [
      _vm.data && _vm.data.length > 0
        ? _c(
            "div",
            { staticClass: "vx-col" },
            _vm._l(_vm.data, function(log, index) {
              return _c(
                "vs-alert",
                { key: index, staticClass: "mb-3", attrs: { active: "true" } },
                [
                  _c("div", { staticClass: "vx-col w-full" }, [
                    _c("div", [
                      _vm._v(
                        _vm._s(log.name) +
                          " (" +
                          _vm._s(log.username) +
                          ") - " +
                          _vm._s(log.action)
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "vx-col w-full" }, [
                    _c("div", { staticClass: "small" }, [
                      _vm._v(
                        _vm._s(
                          _vm.renderDateTimeFormatByTimezone(log.created_at)
                        )
                      )
                    ])
                  ])
                ]
              )
            }),
            1
          )
        : _c("div", { staticClass: "vx-col text-center" }, [
            _c("i", [_vm._v("--- No log found ---")])
          ]),
      _vm._v(" "),
      _c("vs-divider", { staticClass: "mb-base" }),
      _vm._v(" "),
      _c(
        "vs-button",
        {
          staticClass: "mt-5 mr-2 float-right",
          attrs: { type: "flat" },
          on: {
            click: function($event) {
              return _vm.closePopupDialog()
            }
          }
        },
        [_vm._v(_vm._s(_vm.$t("action.close").toUpperCase()))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }